module.exports = __webpack_public_path__ + "img/defaultbanner.cc7b3671.png";